<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 600.000000 600.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,600.000000) scale(0.100000,-0.100000)"
      fill="#883999"
      stroke="none"
    >
      <path
        d="M2830 5994 c-362 -31 -642 -92 -917 -199 -947 -372 -1637 -1187
  -1847 -2182 -45 -215 -59 -358 -59 -613 0 -255 14 -398 59 -613 210 -995 900
  -1810 1847 -2182 348 -136 689 -198 1087 -198 255 0 398 14 613 59 995 210
  1810 900 2182 1847 136 348 198 689 198 1087 0 398 -62 739 -198 1087 -404
  1029 -1333 1751 -2426 1888 -121 15 -450 27 -539 19z m502 -1108 c480 -75 781
  -298 902 -669 74 -225 72 -523 -4 -742 -105 -304 -362 -553 -690 -669 -41 -15
  -81 -29 -88 -31 -10 -4 2 -23 35 -59 115 -125 204 -258 578 -856 153 -245 300
  -480 327 -523 l48 -77 -387 0 -388 1 -310 501 c-170 276 -342 545 -381 597
  -144 193 -288 303 -416 317 l-58 7 0 -712 0 -711 -345 0 -345 0 0 944 0 945
  623 4 c555 3 630 5 692 21 232 59 386 208 447 433 16 61 21 108 21 213 0 120
  -2 144 -26 216 -63 189 -191 310 -382 359 -79 20 -272 20 -350 0 -181 -47
  -309 -178 -331 -338 l-7 -47 193 -2 192 -3 -352 -283 c-193 -156 -357 -285
  -365 -288 -9 -4 -145 106 -353 283 l-340 288 168 3 c186 3 171 -3 185 72 21
  112 91 281 163 388 145 219 430 380 747 421 44 6 94 13 110 15 62 9 394 -4
  487 -18z"
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RecurlyLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>
